// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerFlex {
  display: flex;
}

.childflex {
  min-width: 400px;
  max-width: 300px;
  flex-basis: 300px;
}

.invoice-title {
  background: var(--button-a-background);
  color: var(--button-a-text);
  padding: 10px;
  border-radius: 20px;
  text-align: center;
  margin: 10px 10px 10px 10px;
}

.item-size ion-item {
  --min-height: 40px;
}

.order-item-box {
  --padding-end: 0px;
  --inner-padding-end: 0px;
}

.status-box {
  padding: 0;
  width: 40%;
  margin: auto;
  color: #fff;
}

.status-box.margin-bottom {
  margin-bottom: 3px;
}

.price {
  text-align: end;
  font-size: 14px;
}

.text-box {
  font-size: 14px;
}
.text-box ion-badge {
  --background: var(--button-b-background);
  color: var(--button-b-text);
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  align-items: flex-start;
  gap: 5px;
}

.code-text {
  color: #8a8c8e;
  font-size: 14px;
  padding-right: 10px;
}

.amount-col {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.amount-box {
  font-size: 12px;
  text-align: start;
  direction: ltr;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.amount-box .units {
  margin: 0 2px;
  direction: rtl;
  display: inline-block;
  text-align: end;
}
.amount-box .units span {
  margin: 0 2px;
}

ion-item-group ion-item.details-item {
  --min-height: 35px;
}
ion-item-group ion-label.field-label {
  max-width: 35%;
  min-width: 35%;
  margin: 0;
}

.details-size {
  width: 65%;
}

.vert-box {
  max-height: 56px;
  text-align: center;
}

.invoice-box {
  background: var(--button-b-background);
  color: var(--button-b-text);
  padding: 10px;
  border-radius: 20px;
  margin: 5px 0;
}

ion-item-divider {
  background: var(--main-top);
  color: var(--main-top-text);
  border-radius: 20px;
  margin: 5px 0;
}

ion-list.circle-list {
  padding: 0;
}

.props-box {
  font-size: 13px;
}

ion-badge.ion-color.ion-color-warning {
  color: inherit;
}

/* ============================================
   PAYMENT SECTION STYLES
   ============================================ */
ion-card, .payment-card {
  background: var(--element-background);
  border-radius: 16px;
  margin: 8px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.payment-header {
  background: linear-gradient(135deg, var(--button-a-background) 0%, var(--button-a-over) 100%);
  padding: 20px;
  color: var(--button-a-text);
  border-radius: 0;
}

.payment-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.payment-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 200px;
}

.payment-header-icon {
  font-size: 32px;
  opacity: 0.9;
}

.payment-header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
}

.payment-header-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  opacity: 0.85;
}

.payment-amount-badge {
  background: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: 12px 20px;
  border-radius: 12px;
  text-align: center;
  min-width: 140px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.amount-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.85;
  margin-bottom: 4px;
  font-weight: 500;
}

.amount-value {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.amount-value ::ng-deep.price-div {
  justify-content: center;
}

.payment-content {
  padding: 24px 20px;
}

.payment-options-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--button-a-text);
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.7;
}

.payment-method-btn {
  margin: 0 0 12px 0;
  height: auto;
  --border-radius: 12px;
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-transform: none;
  font-weight: normal;
  transition: all 0.3s ease;
}
.payment-method-btn:hover {
  transform: translateY(-2px);
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.payment-method-btn:active {
  transform: translateY(0);
}

.primary-payment {
  --background: var(--button-a-background);
  --background-hover: var(--button-a-over);
  --background-activated: var(--button-a-over);
  --color: var(--button-a-text);
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-start: 20px;
  --padding-end: 20px;
}

.secondary-payment {
  --background: var(--element-background);
  --background-hover: var(--app-background);
  --background-activated: var(--app-background);
  --color: var(--button-a-text);
  --border-width: 2px;
  --border-style: solid;
  --border-color: rgba(0, 0, 0, 0.1);
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-start: 20px;
  --padding-end: 20px;
}

.payment-btn-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: start;
}

.payment-btn-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.payment-btn-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.payment-btn-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.payment-btn-subtitle {
  font-size: 12px;
  opacity: 0.7;
  line-height: 1.3;
}

.payment-btn-arrow {
  font-size: 20px;
  opacity: 0.5;
  flex-shrink: 0;
}

.external-payment-section {
  margin-top: 8px;
}

.payment-divider {
  display: flex;
  align-items: center;
  margin: 20px 0;
  color: var(--button-a-text);
  opacity: 0.4;
}
.payment-divider::before, .payment-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid currentColor;
}
.payment-divider span {
  padding: 0 12px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.payment-security-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  color: var(--button-a-text);
  font-size: 12px;
  opacity: 0.6;
}
.payment-security-badge ion-icon {
  font-size: 16px;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .payment-header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .payment-amount-badge {
    width: 100%;
  }
  .payment-btn-title {
    font-size: 15px;
  }
  .payment-btn-subtitle {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/core/pages/order/components/order-content/order-content.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EAEE,gBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAIA;EACE,sCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AADF;;AAKE;EACE,kBAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,eAAA;AAHF;;AAOA;EACE,eAAA;AAJF;AAOE;EACE,wCAAA;EACA,2BAAA;EAEA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,uBAAA;EACA,QAAA;AANJ;;AAUA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAPF;;AAUA;EAEE,aAAA;EACA,8BAAA;EACA,sBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,6BAAA;AATF;AAYE;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAVJ;AAYI;EACE,aAAA;AAVN;;AAgBE;EACE,kBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,cAAA;EACA,SAAA;AAdJ;;AAkBA;EACE,UAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,sCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AAfF;;AAmBA;EACE,UAAA;AAhBF;;AAyBA;EACE,eAAA;AAtBF;;AA0BA;EACI,cAAA;AAvBJ;;AAgCA;;iDAAA;AAIA;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,6FAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;AA9BF;;AAiCA;EACE,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AA9BF;AAgCC;EACG,uBAAA;AA9BJ;;AAkCA;EACE,kBAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AA/BF;AAiCE;EACE,2BAAA;EACA,4CAAA;AA/BJ;AAkCE;EACE,wBAAA;AAhCJ;;AAoCA;EACE,wCAAA;EACA,wCAAA;EACA,4CAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,uCAAA;EACA,yCAAA;EACA,6CAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,eAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,YAAA;AAjCF;AAmCE;EAEE,WAAA;EACA,OAAA;EACA,qCAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AApCF;AAsCE;EACE,eAAA;AApCJ;;AAwCA,2BAAA;AACA;EACE;IACE,sBAAA;IACA,uBAAA;EArCF;EAwCA;IACE,WAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,eAAA;EAxCF;AACF","sourcesContent":[".containerFlex {\n  display: flex;\n}\n\n.childflex {\n\n  min-width: 400px;\n  max-width: 300px;\n  flex-basis: 300px;\n}\n\n\n.invoice-title {\n  background: var(--button-a-background);\n  color: var(--button-a-text);\n  padding: 10px;\n  border-radius: 20px;\n  text-align: center;\n  margin: 10px 10px 10px 10px;\n}\n\n.item-size {\n  ion-item {\n    --min-height: 40px;\n  }\n}\n\n.order-item-box {\n  --padding-end: 0px;\n  --inner-padding-end: 0px;\n}\n\n.status-box {\n  padding: 0;\n  width: 40%;\n  margin: auto;\n  color: #fff;\n}\n\n.status-box.margin-bottom {\n  margin-bottom: 3px;\n}\n\n.price {\n  text-align: end;\n  font-size: 14px;\n  //margin-top: 5px;\n}\n\n.text-box {\n  font-size: 14px;\n  //padding-right: 10px;\n\n  ion-badge {\n    --background: var(--button-b-background);\n    color: var(--button-b-text);\n\n    display: flex;\n    width: fit-content;\n    align-items: flex-start;\n    gap: 5px;\n  }\n}\n\n.code-text {\n  color: #8a8c8e;\n  font-size: 14px;\n  padding-right: 10px;\n}\n\n.amount-col {\n\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n.amount-box {\n  font-size: 12px;\n  text-align: start;\n  direction: ltr;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n\n\n  .units {\n    margin: 0 2px;\n    direction: rtl;\n    display: inline-block;\n    text-align: end;\n\n    span {\n      margin: 0 2px;\n    }\n  }\n}\n\nion-item-group {\n  ion-item.details-item {\n    --min-height: 35px;\n  }\n\n  ion-label.field-label {\n    max-width: 35%;\n    min-width: 35%;\n    margin: 0;\n  }\n}\n\n.details-size {\n  width: 65%;\n}\n\n.vert-box {\n  max-height: 56px;\n  text-align: center;\n}\n\n.invoice-box {\n  background: var(--button-b-background);\n  color: var(--button-b-text);\n  padding: 10px;\n  border-radius: 20px;\n  margin: 5px 0;\n}\n\nion-item-divider {\n  background: var(--main-top);\n  color: var(--main-top-text);\n  border-radius: 20px;\n  margin: 5px 0;\n\n}\n\nion-list.circle-list {\n  padding: 0;\n}\n\nion-item-group {\n  ion-label {\n    //max-width: 50%;\n  }\n}\n\n.props-box {\n  font-size: 13px;\n}\n\n\nion-badge.ion-color.ion-color-warning {\n    color: inherit;\n}\n\n//\n//ion-badge {\n//  --background: var(--button-a-background);\n//  --color: var(--button-a-text);\n//}\n\n/* ============================================\n   PAYMENT SECTION STYLES\n   ============================================ */\n\nion-card, .payment-card {\n  background: var(--element-background);\n  border-radius: 16px;\n  margin: 8px 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.payment-header {\n  background: linear-gradient(135deg, var(--button-a-background) 0%, var(--button-a-over) 100%);\n  padding: 20px;\n  color: var(--button-a-text);\n  border-radius: 0;\n}\n\n.payment-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.payment-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 200px;\n}\n\n.payment-header-icon {\n  font-size: 32px;\n  opacity: 0.9;\n}\n\n.payment-header-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.payment-header-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  opacity: 0.85;\n}\n\n.payment-amount-badge {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  padding: 12px 20px;\n  border-radius: 12px;\n  text-align: center;\n  min-width: 140px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.amount-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.85;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.amount-value {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n\n ::ng-deep.price-div{\n    justify-content: center;\n  }\n}\n\n.payment-content {\n  padding: 24px 20px;\n}\n\n.payment-options-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--button-a-text);\n  margin-bottom: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.7;\n}\n\n.payment-method-btn {\n  margin: 0 0 12px 0;\n  height: auto;\n  --border-radius: 12px;\n  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  text-transform: none;\n  font-weight: normal;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.primary-payment {\n  --background: var(--button-a-background);\n  --background-hover: var(--button-a-over);\n  --background-activated: var(--button-a-over);\n  --color: var(--button-a-text);\n  --padding-top: 16px;\n  --padding-bottom: 16px;\n  --padding-start: 20px;\n  --padding-end: 20px;\n}\n\n.secondary-payment {\n  --background: var(--element-background);\n  --background-hover: var(--app-background);\n  --background-activated: var(--app-background);\n  --color: var(--button-a-text);\n  --border-width: 2px;\n  --border-style: solid;\n  --border-color: rgba(0, 0, 0, 0.1);\n  --padding-top: 16px;\n  --padding-bottom: 16px;\n  --padding-start: 20px;\n  --padding-end: 20px;\n}\n\n.payment-btn-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: start;\n}\n\n.payment-btn-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.payment-btn-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.payment-btn-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.payment-btn-subtitle {\n  font-size: 12px;\n  opacity: 0.7;\n  line-height: 1.3;\n}\n\n.payment-btn-arrow {\n  font-size: 20px;\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n.external-payment-section {\n  margin-top: 8px;\n}\n\n.payment-divider {\n  display: flex;\n  align-items: center;\n  margin: 20px 0;\n  color: var(--button-a-text);\n  opacity: 0.4;\n\n  &::before,\n  &::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid currentColor;\n  }\n\n  span {\n    padding: 0 12px;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-weight: 500;\n  }\n}\n\n.payment-security-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 20px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n  color: var(--button-a-text);\n  font-size: 12px;\n  opacity: 0.6;\n\n  ion-icon {\n    font-size: 16px;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .payment-header-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .payment-amount-badge {\n    width: 100%;\n  }\n\n  .payment-btn-title {\n    font-size: 15px;\n  }\n\n  .payment-btn-subtitle {\n    font-size: 11px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
